import React from 'react'
import { Icon, Card } from '../../../atoms'
import { connect } from 'react-redux'
import { brand } from '../../../redux/app-selectors'

interface IListItemsDetails {
  title: string
  prosTitle: string
  consTitle: string
  prosList: Array<string>
  consList: Array<string>
}

interface ProsConsCardProps {
  name: string
  jsonBody: IListItemsDetails
  showHeader: boolean
  brand: 'money' | 'uswitch' | 'confused'
}

const getIcon = (brand: string, glyph: 'cross' | 'tick') => {
  switch (brand) {
    case 'uswitch':
      return <Icon glyph={`${glyph}-square`} size='32' color='#141414' />
    case 'confused':
      return <Icon glyph={`${glyph}-circle`} size='45' color='#141414' />
    default:
      return <Icon glyph={`${glyph}-circle`} size='26' color='#924A8B' />
  }
}

const ProsConsCard = ({ jsonBody, name, showHeader, brand }: ProsConsCardProps) => {
  const { title, prosTitle, consTitle, prosList, consList } = jsonBody
  try {
    return (
      <div className='pros-cons' id={name}>
        {showHeader && <h2 className='pros-cons__heading'>{title}</h2>}
        <div className='pros-cons__container'>
          <Card variant='modal' className={brand === 'confused' ? 'pros-cons__card' : ''}>
            <div className='pros-cons__container__box'>
              {prosTitle && brand === 'confused' ? (
                <div className='pros-cons__container__box__title'>
                  <h2 className='pros-cons__container__box__text'>{prosTitle}</h2>
                </div>
              ) : (
                prosTitle && <h3 className='pros-cons__container__box__text'>{prosTitle}</h3>
              )}
              <div className='pros-cons__container__box__list'>
                {prosList.map((ele, i) => (
                  <div key={i} className='pros-cons__container__box__list__container'>
                    <div>{getIcon(brand, 'tick')}</div>
                    <span className='pros-cons__container__box__list__text'>{ele}</span>
                  </div>
                ))}
              </div>
            </div>
          </Card>
          <Card variant='modal' className={brand === 'confused' ? 'pros-cons__card' : ''}>
            <div className='pros-cons__container__box'>
              {consTitle && brand === 'confused' ? (
                <div className='pros-cons__container__box__title'>
                  <h2 className='pros-cons__container__box__text'>{consTitle}</h2>
                </div>
              ) : (
                consTitle && <h3 className='pros-cons__container__box__text'>{consTitle}</h3>
              )}
              <div className='pros-cons__container__box__list'>
                {consList.map((ele, i) => (
                  <div key={i} className='pros-cons__container__box__list__container'>
                    <div>
                      <div>{getIcon(brand, 'cross')}</div>
                    </div>
                    <span className='pros-cons__container__box__list__text'>{ele}</span>
                  </div>
                ))}
              </div>
            </div>
          </Card>
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(ProsConsCard)
